import React from 'react';
import PropTypes from 'prop-types';
import { compose } from "recompose";
import { connect } from "react-redux";
import { withStyles, Tabs, Tab } from "@material-ui/core";
import t from "../../languages/pl";

const StyledTabs = withStyles({
	indicator: {
		display: 'flex',
		justifyContent: 'center',
	},
})((props) => <Tabs {...props} />);

const StyledTab = withStyles((theme) => ({
	root: {
		marginRight: theme.spacing(1),
		'&:focus': {
			opacity: 1,
		},
	},
}))((props) => <Tab disableRipple {...props} />);

const useStyles = theme => ({
	tabs: {
		padding: theme.spacing(1)
	}
});

const SettingsTabs = props => {
	const { classes, value, onTabChange, isGpsEnabled, role } = props;

	return (
		<StyledTabs
			className={classes.tabs}
			value={value}
			onChange={(e, newValue) => onTabChange(newValue)}
			centered
			indicatorColor="primary"
		>
			<StyledTab label={t.general} index={0} />
			<StyledTab label={t.schedules} index={1} />
			{(isGpsEnabled && role === 'admin') && <StyledTab label="POI"
						index={2}
			/>}
		</StyledTabs>
	);
};

const mapStateToProps = state => ({
	isDrawerOpen: state.requestReducer.isDrawerOpen,
	isGpsEnabled: state.authReducer.isGpsEnabled,
	role: state.authReducer.role
});

SettingsTabs.propTypes = {
	classes: PropTypes.object,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onTabChange: PropTypes.func,
	//redux
	isDrawerOpen: PropTypes.bool,
	isGpsEnabled: PropTypes.bool,
	role: PropTypes.string
};

export default compose(
	connect(
		mapStateToProps
	),
	withStyles(useStyles)
)(SettingsTabs);
